/* eslint-disable better-mutation/no-mutation */

import { createSlice } from '@reduxjs/toolkit';

type RequestState = {
    cookies: NodeJS.Dict<string> | null;
    location: string | null;
    userAgent: string | null;
    request?: unknown;
    response?: unknown;
};

export const initialState: RequestState = {
    cookies: null,
    location: null,
    userAgent: null
};

const slice = createSlice({
    name: 'request',
    initialState,
    reducers: {
        setCookies: (state, { payload }) => {
            state.cookies = payload;
        },
        setLocation: (state, { payload }) => {
            state.location = payload;
        },
        setUserAgent: (state, { payload }) => {
            state.userAgent = payload;
        },
        setRequestAndResponse: (state, { payload }) => {
            state.request = payload.request;
            state.response = payload.response;
        }
    }
});

export const { setCookies, setLocation, setUserAgent, setRequestAndResponse } =
    slice.actions;
export const reducer = slice.reducer;
